import { logWrapper } from '../../utils';
import diacritics from 'diacritics';

export default {
  flowSelectGroupsController: [
    'runtimeConstant',
    '$scope',
    'groups',
    'users',
    function (runtimeConstant, $scope, groups, users) {
      'use strict';

      function filter(item) {
        var filter = diacritics.remove($scope.filterQuery).toLowerCase();
        var name = diacritics.remove(item.Name).toLowerCase();
        return name.indexOf(filter) > -1;
      }

      function run() {
        try {
          $scope.groups = groups;
          $scope.users = users;
          $scope.showGroups = true;
          $scope.showUsers = true;
          $scope.filterQuery = '';

          $scope.filter = logWrapper(
            filter,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
